import { Service } from './service';

const url = {
  SEARCH_LOANS: '/api/v1/loan/searchLoans',
  SEARCH_LOANS_UNIFIED: '/api/v1/loan/unified/searchLoans',
};

export class SearchBarService extends Service {
  searchLoans(searchTerm: string) {
    return this.get(
      url.SEARCH_LOANS,
      {
        keyword: searchTerm,
        start: 1,
        count: 10,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  searchLoansUnified(searchTerm: string) {
    return this.get(
      url.SEARCH_LOANS_UNIFIED,
      {
        keyword: searchTerm,
        count: 10,
        offsets: '0,0',
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
}
